import { render } from "./ValidatePopup.vue?vue&type=template&id=19738ac0&ts=true"
import script from "./ValidatePopup.vue?vue&type=script&lang=ts"
export * from "./ValidatePopup.vue?vue&type=script&lang=ts"

import "./ValidatePopup.vue?vue&type=style&index=0&id=19738ac0&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__